import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="job-announcement-form"
export default class extends Controller {
  static targets = ["usersTable", "radius", "contracts", "wrapper", "submitButton", "search", "userIds", "selectedText", "loader", "nextPageLoader", "noUsersFound"]
  static values = {
    updateUsersTableUrl: String
  }

  connect() {
    this.performUpdateUsersTable();
    if (this.hasSearchTarget) {
      this.searchTarget.addEventListener("input", this.updateUsersTable.bind(this));
    }
  }

  updateUsersTable() {
    this.showLoadingSpinner();
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.performUpdateUsersTable();
    }, 500);
  }

  performUpdateUsersTable() {
    const radius = this.radiusTarget.value;
    const contracts = Array.from(this.contractsTarget.selectedOptions).map(option => option.value);

    let url = `${this.updateUsersTableUrlValue}?radius=${radius}&search=${this.search}`;

    if (contracts && contracts.length > 0) {
      contracts.forEach(contract => {
        url += `&contracts[]=${encodeURIComponent(contract)}`;
      });
    }

    this.usersTableTarget.src = url;
    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.add('hidden');
    }
  }

  nextPageTargetConnected() {
    const event = new CustomEvent("data-added");
    this.wrapperTarget.dispatchEvent(event);
  }

  updateSubmitConfirmationText() {
    const selectedCount = this.usersTableTarget.querySelectorAll('tbody input[type="checkbox"]:checked').length;
    if (selectedCount > 0) {
      this.submitButtonTarget.dataset.confirm = `Are you sure you would like to send this announcement to ${selectedCount} users?`;
    } else {
      this.submitButtonTarget.dataset.confirm = "";
    }
  }

  updateSelectedUsers() {
    const currentStoredUsers = this.userIds ? this.userIds.split(",") : [];
    this.usersTableTarget.querySelectorAll('tbody input[type="checkbox"]').forEach(checkbox => {
      if (currentStoredUsers.includes(checkbox.value)) {
        checkbox.checked = true;
      } else {
        checkbox.checked = false;
      }
    });

    if (this.userIds != "") {
      let selectedCount = this.userIds.split(",").length
      this.selectedTextTarget.textContent = `(${selectedCount} selected)`;
    }
  }

  storeSelectedUsers(e) {
    const selectedUsers = Array.from(this.usersTableTarget.querySelectorAll('tbody input[type="checkbox"]:checked')).map(checkbox => checkbox.value);
    const currentStoredUsers = this.userIds ? this.userIds.split(",") : [];
    const uniqueSelectedUsers = selectedUsers.filter(user => !currentStoredUsers.includes(user));
    currentStoredUsers.push(...uniqueSelectedUsers);
    if (e.detail && e.detail.original_target && !e.detail.original_target.checked) {
      const userIdToRemove = e.detail.original_target.value;
      const indexToRemove = currentStoredUsers.indexOf(userIdToRemove);
      if (indexToRemove !== -1) {
        currentStoredUsers.splice(indexToRemove, 1);
      }
    }

    this.userIdsTarget.value = currentStoredUsers;
  }

  showLoadingSpinner() {
    let table = this.usersTableTarget.querySelector('table')
    if (table) {
      table.classList.add('hidden');
    }

    if (!this.hasNextPageLoaderTarget && this.hasLoaderTarget) {
      this.loaderTarget.classList.remove('hidden');
    }

    if (this.hasNoUsersFoundTarget) {
      this.noUsersFoundTarget.classList.add('hidden');
    }
  }

  get search() {
    if (this.hasSearchTarget) {
      return this.searchTarget.value;
    }
    return "";
  }

  get userIds() {
    return this.userIdsTarget.value;
  }
}
